export default function Job({ jobInfo, handleClick, isActive }) {
    return(
        <div className={`flex items-center ${isActive ? 'selected-job' : ''} rounded my-2 p-2 cursor-pointer`} onClick={() => handleClick(jobInfo.id)}>
            <div className="flex align-middle md:mr-2">
                <img alt={`${jobInfo.company} logo`} className="w-12 h-12 md:w-9 md:h-9" src={`/job-icons/${jobInfo.logoUrl}`} />
            </div>
            <div className="flex-col hidden md:flex">
                <div className="big-p">{jobInfo.company}</div>
                <div className="small-p">{jobInfo.position}</div>
            </div>
        </div>
    )
}